import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const PAY_PAL: PaymentMethod = {
    id: PAYMENT_METHOD_ID.PayPal,
    name: 'paypal'
};
